(function () {
  if (typeof window === 'undefined') return;
  if (window.__lxHeaderFooterInitialized) return;
  window.__lxHeaderFooterInitialized = true;

  // === Global toggle function (callable from inline onclick) ===
  window.lxToggleAccordion = function (btn) {
    var section = btn && btn.closest ? btn.closest('.lx-drawer-section') : null;
    if (!section) return false;
    var isOpen = section.classList.toggle('is-open');
    var list = section.querySelector('.lx-drawer-list');
    if (list) {
      list.style.setProperty('display', isOpen ? 'block' : 'none', 'important');
    }
    var chev = section.querySelector('.lx-chevron');
    if (chev) chev.textContent = isOpen ? '˄' : '˅';
    return false;
  };

  function attachInlineHandlers() {
    var buttons = document.querySelectorAll('.lx-drawer-heading');
    buttons.forEach(function (btn) {
      // FORCE inline onclick (cannot be blocked by other JS)
      btn.setAttribute('onclick', 'return window.lxToggleAccordion(this);');
      btn.style.cursor = 'pointer';

      // Sync initial display state
      var section = btn.closest('.lx-drawer-section');
      if (!section) return;
      var list = section.querySelector('.lx-drawer-list');
      if (list) {
        var isOpen = section.classList.contains('is-open');
        list.style.setProperty('display', isOpen ? 'block' : 'none', 'important');
      }
      var chev = section.querySelector('.lx-chevron');
      if (chev) {
        chev.textContent = section.classList.contains('is-open') ? '˄' : '˅';
      }
    });
  }

  function init() {
    var body = document.body;
    var drawer = document.getElementById('lx-drawer');
    var overlay = document.querySelector('[data-lx-overlay]');
    var openButtons = document.querySelectorAll('.lx-menu-open');
    var closeButton = document.querySelector('.lx-menu-close');

    function openDrawer(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      body.classList.add('lx-drawer-open');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }

    function closeDrawer(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      body.classList.remove('lx-drawer-open');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    attachInlineHandlers();

    // === Capture-phase listener (runs BEFORE all other click handlers) ===
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.lx-drawer-heading') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      window.lxToggleAccordion(btn);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach handlers in case Shopify re-renders DOM
  setTimeout(attachInlineHandlers, 500);
  setTimeout(attachInlineHandlers, 1500);
  setTimeout(attachInlineHandlers, 3000);
})();
